import React from "react";

import BEM from "bem.js";
import classNames from "classnames";
import PropTypes from "prop-types";
import messages from "./messages";
import { msg } from "../translations/components/Message";
import { NUM_STEPS } from "./constants";

export const Nav = ({
    onClick,
    direction,
    highlight,
    step,
    disabled = false,
    isMobile = false
}) => {
    const className = classNames(
        BEM.getBEMClassName("interactive-signup", "navigation"),
        BEM.getBEMClassName("interactive-signup", "navigation", direction),
        {
            [BEM.getBEMClassName(
                "interactive-signup",
                "navigation",
                "highlight"
            )]: highlight,
            mobile: isMobile
        }
    );

    return direction === "prev" ? (
        <button className={className} onClick={onClick}>
            <i className="fa fa-chevron-left" />
        </button>
    ) : (
        <button className={className} onClick={onClick} disabled={disabled}>
            {step !== NUM_STEPS - 1 ? (
                <React.Fragment>
                    <span className="interactive-signup__navigation--text">
                        {msg(messages.nextStep)}
                    </span>
                    <span className="interactive-signup__navigation--text">
                        {" "}
                        {step && `(${step}/${NUM_STEPS})`}
                    </span>
                </React.Fragment>
            ) : (
                <span className="interactive-signup__navigation--text">
                    {msg(messages.completeStep)}
                </span>
            )}

            <i className="fa fa-chevron-right" />
        </button>
    );
};

Nav.propTypes = {
    onClick: PropTypes.func.isRequired,
    direction: PropTypes.oneOf(["next", "prev"]),
    highlight: PropTypes.bool,
    disabled: PropTypes.bool
};

Nav.defaultProps = {
    highlight: false
};
